<div class="flex items-center justify-between content-container">
  <section class="flex pt-10 pb-20 gap-5">
    <app-submenu-items-list
      class="flex mx-auto w-70"
      [title]="'Про фонд'"
      [links]="aboutFundLinks"
      [titleLink]="'/about-us/about-fund/our-idea'"></app-submenu-items-list>
    <app-submenu-items-list
      class="flex mx-auto w-70"
      [title]="'Наші люди'"
      [links]="ourPeopleLinks"
      [titleLink]="'/about-us/our-people'"></app-submenu-items-list>
    <app-submenu-items-list
      class="flex mx-auto w-70"
      [title]="'Напрями діяльності'"
      [links]="ourProgramsLinks"
      [titleLink]="'/about-us/our-programs'"></app-submenu-items-list>
    <app-submenu-items-list
      class="flex mx-auto w-70"
      [title]="'Новини та медіа'"
      [links]="mediaLinks"
      [titleLink]="'/about-us/news-and-media'"></app-submenu-items-list>
  </section>
</div>
